import { resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "on-right text-bold" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "q-pa-sm" }, "Country not found.", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CountrySearch = _resolveComponent("CountrySearch")!
  const _component_q_item_section = _resolveComponent("q-item-section")!
  const _component_q_item = _resolveComponent("q-item")!
  const _component_q_separator = _resolveComponent("q-separator")!
  const _component_dial_code_country_flag = _resolveComponent("dial-code-country-flag")!
  const _component_q_select = _resolveComponent("q-select")!

  return (_openBlock(), _createBlock(_component_q_select, {
    "model-value": _ctx.modelValue,
    options: _ctx.countries,
    "option-value": "iso2",
    "virtual-scroll-slice-size": _ctx.countries.length,
    "popup-content-class": "relative-position",
    "popup-content-style": "height: 300px; max-height: 300px",
    "menu-anchor": "bottom left",
    "hide-bottom-space": "",
    "hide-dropdown-icon": "",
    borderless: "",
    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('update:modelValue', $event))),
    onPopupHide: _cache[3] || (_cache[3] = ($event: any) => (_ctx.searchText = ''))
  }, {
    "before-options": _withCtx(() => [
      _createVNode(_component_CountrySearch, {
        "model-value": _ctx.searchText,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_ctx.searchText = $event))
      }, null, 8, ["model-value"])
    ]),
    option: _withCtx((scope) => [
      (_openBlock(), _createBlock(_component_q_item, _mergeProps({
        key: scope.opt.iso2,
        clickable: ""
      }, scope.itemProps), {
        default: _withCtx(() => [
          _createVNode(_component_q_item_section, { side: "" }, {
            default: _withCtx(() => [
              _createElementVNode("span", {
                class: _normalizeClass(['v3q_tel__flag', scope.opt.iso2.toLowerCase()])
              }, null, 2)
            ]),
            _: 2
          }, 1024),
          _createVNode(_component_q_item_section, { "no-wrap": "" }, {
            default: _withCtx(() => [
              _createElementVNode("span", null, " (+" + _toDisplayString(scope.opt.dialCode) + ") " + _toDisplayString(scope.opt.name), 1)
            ]),
            _: 2
          }, 1024)
        ]),
        _: 2
      }, 1040)),
      _createVNode(_component_q_separator)
    ]),
    "selected-item": _withCtx((scope) => [
      _createVNode(_component_dial_code_country_flag, {
        "dial-code": scope.opt.dialCode
      }, null, 8, ["dial-code"]),
      _createElementVNode("span", _hoisted_1, "+" + _toDisplayString(scope.opt.dialCode), 1)
    ]),
    "no-option": _withCtx(() => [
      _createVNode(_component_CountrySearch, {
        "model-value": _ctx.searchText,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.searchText = $event))
      }, null, 8, ["model-value"]),
      _hoisted_2
    ]),
    _: 1
  }, 8, ["model-value", "options", "virtual-scroll-slice-size"]))
}